import { render, staticRenderFns } from "./liveRoom.vue?vue&type=template&id=19f18462&scoped=true"
import script from "./liveRoom.vue?vue&type=script&lang=js"
export * from "./liveRoom.vue?vue&type=script&lang=js"
import style0 from "./liveRoom.vue?vue&type=style&index=0&id=19f18462&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f18462",
  null
  
)

export default component.exports